// extracted by mini-css-extract-plugin
module.exports = {"itemContainer":"_-_-pharmacy-src-display-feed-userActivityFeed__itemContainer--19bUT"};